import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft, Search } from 'lucide-react';
import Layout from '../Layout';

const NotFoundPage = () => {
  return (
    <Layout>
      <div className="container min-h-screen flex flex-col items-center justify-center text-center py-16 px-4">
        <div className="max-w-2xl mx-auto">
          {/* Error Code */}
          <h1 className="text-9xl font-bold text-primary mb-4">404</h1>
          
          {/* Main Message */}
          <h2 className="text-3xl font-semibold mb-4">
            Oups ! Page introuvable
          </h2>
          
          {/* Explanation */}
          <p className="text-gray-600 text-lg mb-8">
            Désolé, la page que vous recherchez semble avoir été déplacée, supprimée ou n'existe pas.
          </p>
          
          {/* Suggestions */}
          <div className="text-gray-500 mb-8">
            <p>Voici ce que vous pouvez faire :</p>
            <ul className="list-disc list-inside mt-2">
              <li>Vérifier l'URL pour les erreurs de frappe</li>
              <li>Retourner à la page précédente</li>
              <li>Aller à la page d'accueil</li>
            </ul>
          </div>
          
          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/"
              className="inline-flex items-center justify-center px-6 py-3 bg-primary text-white rounded-md hover:bg-primary/90 transition-colors"
            >
              <Home className="w-5 h-5 mr-2" />
              Page d'accueil
            </Link>
            
            <button 
              onClick={() => window.history.back()}
              className="inline-flex items-center justify-center px-6 py-3 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              Page précédente
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default NotFoundPage;